module.exports = __webpack_public_path__ + "img/city (3).f85c440c.png";